/**
 * Detects and groups the errors associated with
 * being unable to redefine non-configurable property "metadata"
 *
 * @param {object} report the Report Object
 * @returns {boolean} Returns true if the report matches
 * @example
 *    can't redefine non-configurable property "metadata"
 */
function firefoxMetadataError(report) {
  if (report.errorMessage.includes("metadata") && navigator.userAgent.includes("Firefox")) {
    report.groupingHash = "FirefoxMetadataError";

    return true;
  }

  return false;
}

export default firefoxMetadataError;
